import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import fetch from "unfetch";
import { getJsonResult, getResult } from "../../services/FetchServices";

const LoginInPage: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [downTimeMessage, setDownTimeMessage] = useState("");
  const [cvpdtUrl, setCvpdtUrl] = useState("");
  const [cvpdtUrlFD, setCvpdtUrlFD] = useState("");
  const history = useHistory();

  const encryptPassword = (password: string) => {
    let asciiArr = password.split("");
    let encryASCIIArr: any = [];
    asciiArr.forEach((element) => {
      let asciiChar = element.charCodeAt(0) + 3;
      let asciiCharMulBy3 = asciiChar * 3;
      encryASCIIArr.push(asciiCharMulBy3);
    });
    let encryPwd = "";
    encryASCIIArr.forEach((element: any) => {
      encryPwd = encryPwd + "*" + element;
    });
    return encryPwd;
  };

  const handleLogIn = async () => {
    var usrdata = username + ":" + password;
    var authHeader = "Basic " + btoa(usrdata);
    localStorage.setItem("userName", username);
    localStorage.setItem("authHeader", authHeader);
    var vendorIdurl =
      `${process.env.REACT_APP_BACKEND_URL}/newLocation/vendorId?authHeader=` +
      authHeader +
      "&userName=" +
      username;
    await fetch(
      `${
        process.env.REACT_APP_BACKEND_URL
      }/login/auth?username=${username}&password=${encryptPassword(password)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      },
    )
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          getResult(vendorIdurl)
            .then((vendorResponse) => vendorResponse.json())
            .then((vendorData) => {
              localStorage.setItem("vendorId", vendorData[0]);
            });
          return response;
        } else {
          throw response;
        }
      })
      .then(() => history.push("/home"))
      .catch((error) => {
        error.text().then((errMessage: any) => {
          if (errMessage.indexOf("401") > -1) {
            setErrorMessage("Password or User ID are wrong");
          } else {
            setErrorMessage("A problem occurred, please try again later.");
          }
        });
      });
  };

  const handleUsername = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(e.target.value);
  };

  const handlePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") {
      handleLogIn();
    }
  };

  useEffect(() => {
    var url = `${process.env.REACT_APP_BACKEND_URL}/login/getMessage`;
    getJsonResult(url)
      .then((response) => response.json())
      .then((data: any) => {
        setDownTimeMessage(data?.[0]);
      });
    var cvpRedirectUrl = `${process.env.REACT_APP_BACKEND_URL}/login/getRedirectProps`;
    getJsonResult(cvpRedirectUrl)
      .then((response) => response.json())
      .then((data: any) => {
        setCvpdtUrl(data?.[0]);
      });
    var cvpRedirectUrlFD = `${process.env.REACT_APP_BACKEND_URL}/login/getFDRedirectProps`;
    getJsonResult(cvpRedirectUrlFD)
      .then((response) => response.json())
      .then((data: any) => {
        setCvpdtUrlFD(data?.[0]);
      });
  }, []);

  return (
    <>
      <div className="body-login">
        <div
          className="fd-notice-message"
          style={{ paddingLeft: "50px", paddingTop: "10px", fontSize: "15px" }}
        >
          <h1
            style={{ fontSize: "20px", fontWeight: "bold" }}
            id="fd-vendors-notice"
          >
            Family Dollar Vendors
          </h1>
          <p id="fd-release-message">
            The CVP for Family Dollar will be down from Friday,{" "}
            <b>
              <u>August 7 at 5pm EDT </u>
            </b>
            through{" "}
            <b>
              <u>Monday, August 10 at 8 am EDT </u>
            </b>
            .
          </p>
          <p id="fd-release-link">
            Please note the web address for the Family Dollar CVP will change on
            <b>
              <u> Monday, August 10</u>
            </b>
            .
          </p>
        </div>
        <div
          className="dt-notice-message"
          style={{ paddingLeft: "50px", paddingTop: "10px", fontSize: "15px" }}
        >
          <h1
            style={{ fontSize: "20px", fontWeight: "bold" }}
            id="dt-vendors-notice"
          >
            Dollar Tree Vendors
          </h1>
          <p id="dt-release-message">
            Access to history and releasing of Dollar Tree PO’s with start ship
            dates prior to{" "}
            <b>
              <u>July 4th</u>
            </b>{" "}
             has been disabled permanently as we have changed Transportation
            Management Systems.
          </p>
          <p id="dt-release-link">
            To release and view Dollar Tree PO's where the early ship date on
            the PO is 
            <b>
              <u>July 5 or later</u>
            </b>
            , {` click `}
            {cvpdtUrl ? (
              <a id="dt-release-link-id" target="_blank" href={cvpdtUrl}>
                here
              </a>
            ) : (
              <span style={{ color: "gray", cursor: "not-allowed" }}>here</span>
            )}{" "}
            to be redirected to Manhattan's Active Transportation Management
            System, click Log In, and enter your new credentials on Manhattan's
            log in screen.
            <br></br>
            <br></br>
            Please reach out to your regular Dollar Tree or Family Dollar
            Representative with questions.
          </p>
          <p id="dt-release-note">
            <b>NOTE:</b> Beginning September 1, this landing page
            (cvp.dollartree.com) will become the official login page for the
            Dollar Tree CVP.  Please continue to save this bookmark.
          </p>
        </div>
      </div>
    </>
  );
};

export default LoginInPage;
